'use client';

import dynamic from 'next/dynamic';

const ErrorComponent = dynamic(() => import('./error'), { ssr: false });

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    // global-error must include html and body tags
    // https://nextjs.org/docs/app/building-your-application/routing/error-handling
    <html>
      <body>
        <ErrorComponent error={error} />
      </body>
    </html>
  );
}
